import type {GraphAtom} from "../graph/GraphAtom";
import {MolecularGraph} from "../graph/MolecularGraph";
import {Feature, Features} from "../feature";
import {extractorUtil} from "../util/extractorUtil";

const getSharedAtoms = (arr1: GraphAtom[], arr2: GraphAtom[]) =>
    arr1.filter(a => arr2.includes(a))

export const bridgeheadFilter = {
    filterInPlace: (features: Feature[], graph: MolecularGraph) => {
        const ringFeatures = features.filter(f => f.name.includes(Features.ring));
        const bridgedRings = [];

        for (let i = 0; i < ringFeatures.length - 1; i++) {
            const ring1 = ringFeatures[i];
            for (let j = i + 1; j < ringFeatures.length; j++) {
                const ring2 = ringFeatures[j];
                const sharedAtoms = getSharedAtoms(ring1.atoms, ring2.atoms)
                if (sharedAtoms.length > 2) {
                    bridgedRings.push([ring1, ring2]);
                }
            }
        }

        // Remove all the bridged rings from the feature list.
        bridgedRings.flat().forEach(r => features.splice(features.indexOf(r), 1))

        // For each pair of bridged rings, create a new bridged feature and add it to the list.
        const bridgedFeatures = bridgedRings.map(pair => {
            const r1 = pair[0];
            const r2 = pair[1];

            const sharedAtoms = getSharedAtoms(r1.atoms, r2.atoms);

            const allAtoms = Array.from(new Set([...r1.atoms, ...r2.atoms]));
            const allConnections = Array.from(new Set([...r1.connections, ...r2.connections]))
                .filter(a => !allAtoms.includes(a))

            return {
                name: `${Features.bridgedRing}.${allAtoms.length}`,
                atoms: allAtoms,
                connections: allConnections,
                bridge: extractorUtil.getInternalBonds(sharedAtoms, graph)
            }
        })

        features.push(...bridgedFeatures)
        return features;
    }
}
